import { Spinner } from "@chakra-ui/react";

type Props = {
  inputState: string;
  visibleOnStates: string[];
};

export default function BadgeSpinner({ inputState, visibleOnStates }: Props) {
  return visibleOnStates.includes(inputState.toUpperCase()) ? (
    <Spinner emptyColor="gray.400" ml={2} size="xs" />
  ) : null;
}
